import React from 'react';
import classNames from 'classnames';
import MsgConfigSection from '../msg-config-section';
import { MessageConfigItem } from '../../../../interfaces';
import { platformIntl } from '../../../../../../constants';

interface EmailMsgConfigProps {
    className?: string;
    config?: MessageConfigItem;
    onUpdateConfig: (config: MessageConfigItem) => void;
}

/**
 * 邮件消息渠道配置
 */
const EmailMsgConfig: React.FC<EmailMsgConfigProps> = (props) => {
    const { className, config, onUpdateConfig } = props;

    if (!config) {
        return null;
    }

    return (
        <MsgConfigSection
            className={classNames('fx-email-msg-config', className)}
            checkProps={{
                checked: config.enable,
                text: platformIntl.get('mail'),
                onCheck: (value) => {
                    onUpdateConfig({ ...config, enable: value });
                }
            }}
            receiverProps={{
                receivers: config.target,
                onReceiverChange: (receiver) => {
                    onUpdateConfig({ ...config, target: receiver });
                }
            }}
            messageChannel="email"
        />
    );
};

export default EmailMsgConfig;
